@if (ticket && subscription) {
<div>
    @if (isTicketView) {
    <div>
        <div class="mb-3">
            <button name="back" class="btn btn-outline-primary" [routerLink]="['/support']">{{ 'app_back' | i18next
                }}</button>
        </div>
        <div class="d-flex flex-row align-items-center mb-3 ml-3 mr-3">
            <div class="h3">{{ ticket.title }}</div>
            @if (isTicketClosable) {
            <div class="ml-auto bd-highlight">
                <button name="close-ticket" class="btn btn-outline-primary" (click)="closeTicket()"
                    [disabled]="isRequesting">{{ 'support_ticket_close' | i18next }}</button>
            </div>
            }
        </div>
        <div class="ticket">
            <div class="sub">
                <div class="d-flex">
                    <span>{{ "support_ticket_number" | i18next }} {{ ticket.ticketId }}</span>
                    <span class="ml-3">{{ "support_ticket_created" | i18next }} {{ ticket.createdAt * 1000 |
                        localized_datetime }}</span>
                    <span class="ml-3">{{ "support_ticket_state" | i18next }} {{ supportService.getTicketStateTranslationKey(ticket.state) | i18next }}</span>

                    @if (subscription) {
                    <span class="ml-3">
                        {{ "support_ticket_subscription" | i18next }}
                        @if (isLink) {
                        <a [routerLink]="['/subscriptions', subscription.appliance_id]" class="btn-link ml-1" name="appliance">
                            <span>[{{ subscription.appliance_id }}]</span>
                            <span class="ml-1">{{ subscription.name }}</span>
                        </a>
                        } @else {
                        <span>[{{ subscription.appliance_id }}]</span>
                        <span class="ml-1">{{ subscription.name }}</span>
                        }
                    </span>
                    }
                </div>
            </div>
            @if (!isTicketClosed) {
            <div class="editor mt-3 mb-4">
                <app-article-editor [(message)]="message"></app-article-editor>
                <div class="d-flex bd-highlight mt-3 mb-3">
                    <div class="mr-auto ticket">
                        @if (!isRequesting) {
                        <app-file-uploader [customUpload]="true" [maxFileSize]="10485760" [multipleFiles]="true"
                            [maxFileLength]="3" allowedFiles="*" [enableClipboardPaste]="true"
                            [showUploadButton]="false" (selected)="selectedFilesChanged($event)" class="responsive-uploader"></app-file-uploader>
                        }
                    </div>
                    <div>
                        <button name="detail" class="btn btn-outline-primary" (click)="submitMessage()"
                            [disabled]="isRequesting || !message || isUploading">{{'app_reply' |
                            i18next}}</button>
                    </div>
                </div>
            </div>
            }
            @if (ticket.conversationEntries.length > 0) {
            <div class="articles">
                @for (conversation of ticket.conversationEntries; track conversation) {
                <app-conversation-entry-card [ticketId]="ticket.threadId" [conversationEntry]="conversation"
                    (onAttachmentClicked)="downloadAttachment($event)"></app-conversation-entry-card>
                }
            </div>
            }
        </div>
    </div>
    }
    @if (!isTicketView) {
    <app-close-ticket-warning [ticketNumber]="ticket.ticketId" (confirm)="onCloseConfirm()"
        (back)="onCloseCancel()"></app-close-ticket-warning>
    }
</div>
}